<template>
  <v-menu
    v-model="openMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :label="$t(`entity.${entity}.${keyField}.label`)"
      v-model="componentValue"
      prepend-icon="query_builder"
      readonly
    />
    <v-time-picker 
      v-model="componentValue"
      autosave
      format="24hr"/>
  </v-menu>
</template>

<script>
// const debug = require('debug')('OD::BaseFormHour')

export default {
  name: 'BaseFormHour',
  components: {},
  props: {
    keyField: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openMenu: false,
      componentValue: '',
    }
  },
  computed: {},
  watch: {
    componentValue() {
      this.$emit('update:value', this.componentValue)
    },
    value() {
      this.componentValue = this.value
    },
  },
  created() {
    this.chargeData()
  },
  methods: {
    chargeData() {
      if (this.value) {
        this.componentValue = this.value
      } else {
        this.componentValue = '00:00'
      }
    },
  },
}
</script>

<style>

</style>
